import { render } from "./StatusLayout.vue?vue&type=template&id=24caa4b5"
import script from "./StatusLayout.vue?vue&type=script&lang=js"
export * from "./StatusLayout.vue?vue&type=script&lang=js"

import "./StatusLayout.vue?vue&type=style&index=0&id=24caa4b5&lang=css"

import exportComponent from "/codebuild/output/src3978725497/src/App-Center-Internal-Apps/src/call2teams-integration/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__